import { ANALYTICS_EVENTS } from '../../../library/analytics/constants'
import analyticsModule from '../../../library/analytics/index'

export const trackUnfoldExpenseActivity = () => analyticsModule.getMixpanelInstance().track(ANALYTICS_EVENTS.unfoldExpenseActivity)
export const trackAddPurchaseOrder = () => analyticsModule.getMixpanelInstance().track(ANALYTICS_EVENTS.addPurchaseOrder)
export const trackAddExpense = () => analyticsModule.getMixpanelInstance().track(ANALYTICS_EVENTS.addExpense)
export const trackEditMarkup = () => analyticsModule.getMixpanelInstance().track(ANALYTICS_EVENTS.editMarkup)
export const trackEditSellingPrice = () => analyticsModule.getMixpanelInstance().track(ANALYTICS_EVENTS.editSellingPrice)
